import { createElementVNode as _createElementVNode, openBlock as _openBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79e3094b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottom-navigation_wrapper" }
const _hoisted_2 = { class: "bottom-navigation_btn__wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_2242_3252)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      class: "svgFilled",
      d: "M2 11H22V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V11ZM17 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V9H2V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H7V1H9V3H15V1H17V3Z",
      fill: "#C7D2E1"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_2242_3252" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "24",
        height: "24",
        fill: "white"
      })
    ])
  ])
], -1))
const _hoisted_4 = { class: "bottom-navigation_btn__wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_3168_9275)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      class: "svgFilled",
      d: "M12.414 5H21C21.2652 5 21.5196 5.10536 21.7071 5.29289C21.8946 5.48043 22 5.73478 22 6V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H10.414L12.414 5ZM13 13V9H11V13H8L12 17L16 13H13Z",
      fill: "#C7D2E1"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_3168_9275" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "24",
        height: "24",
        fill: "white"
      })
    ])
  ])
], -1))
const _hoisted_6 = { class: "bottom-navigation_btn__wrapper" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_2242_3257)" }, [
    /*#__PURE__*/_createElementVNode("path", {
      class: "svgFilled",
      d: "M6.455 19L2 22.5V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19H6.455ZM7 10V12H9V10H7ZM11 10V12H13V10H11ZM15 10V12H17V10H15Z",
      fill: "#C7D2E1"
    })
  ]),
  /*#__PURE__*/_createElementVNode("defs", null, [
    /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_2242_3257" }, [
      /*#__PURE__*/_createElementVNode("rect", {
        width: "24",
        height: "24",
        fill: "white"
      })
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ac_button = _resolveComponent("ac-button")!
  const _component_ac_bottom_navigation = _resolveComponent("ac-bottom-navigation")!

  return (_openBlock(), _createBlock(_component_ac_bottom_navigation, {
    class: "bottom-navigation",
    fixed: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ac_button, {
          class: _normalizeClass(["bottom-navigation_btn", {
          '-current': _ctx.currentPage === 'course'
        }]),
          variant: "text",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToCalendar())),
          disabled: _ctx.currentPage === 'course'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('course')), 1)
            ])
          ]),
          _: 1
        }, 8, ["class", "disabled"]),
        _createVNode(_component_ac_button, {
          class: _normalizeClass(["bottom-navigation_btn", {
          '-current': _ctx.currentPage === 'materials'
        }]),
          variant: "text",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToMaterials())),
          disabled: _ctx.currentPage === 'materials'
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('documents')), 1)
            ])
          ]),
          _: 1
        }, 8, ["class", "disabled"]),
        (_ctx.isShowBtnChat)
          ? (_openBlock(), _createBlock(_component_ac_button, {
              key: 0,
              class: _normalizeClass(["bottom-navigation_btn", {
          '-current': _ctx.currentPage === 'chat'
        }]),
              variant: "text",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToChat())),
              disabled: _ctx.currentPage === 'chat'
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('messages')), 1)
                ])
              ]),
              _: 1
            }, 8, ["class", "disabled"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}